import _Vue from 'vue';
import AlertComponent from './Alert.vue';
import { AlertOptions } from './AlertOptions';
import { Alert } from './Alert';

function createRoot() {
  const div = document.createElement('div');
  document.body.append(div);
  return div;
}

export default function(Vue: typeof _Vue, options?: AlertOptions) {
  const containerComponent: any = new AlertComponent(options)
    .$mount(createRoot());
  
  function AlertInterface(options: Alert): void {
    containerComponent.addAlert(options);
  }

  AlertInterface.warning = (title: string, description?: string) => {
    containerComponent.addAlert({ title, description, type: 'warning' });
  }

  AlertInterface.danger = (title: string, description?: string) => {
    containerComponent.addAlert({ title, description, type: 'danger' });
  }

  AlertInterface.success = (title: string, description?: string) => {
    containerComponent.addAlert({ title, description, type: 'success' });
  }

  AlertInterface.info = (title: string, description?: string) => {
    containerComponent.addAlert({ title, description, type: 'info' });
  }

  return AlertInterface;
}